import { Table } from '@/components/warehouse/table'

export const Warehouses = () => {
  return (
    <>
      <Table pageSize={20} createable onIndex />
    </>
  )
}
